import { defineMessages } from 'react-intl';

const MESSAGES = defineMessages({
    search: {
        id: 'blsq.table.label.search',
        defaultMessage: 'Search',
    },
    close: {
        id: 'blsq.table.label.close',
        defaultMessage: 'Close',
    },
    resetSearch: {
        id: 'blsq.table.label.resetSearch',
        defaultMessage: 'Empty search',
    },
    columnSelect: {
        id: 'blsq.table.columnSelect.tooltip',
        defaultMessage: 'Select visible columns',
    },
    apply: {
        defaultMessage: 'Apply',
        id: 'iaso.label.apply',
    },
});
export { MESSAGES };
